// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3lNar","footer":"ChangeClinic_footer__1uSlq"};